import { Spinner } from "components/elements";
import { cn } from "lib/cn";

export const LoadingOverlay = ({ className }: { className?: string }) => {
    return (
        <div className={cn("flex flex-1 flex-col items-center gap-2", className)}>
            <Spinner className="text-slate-500" />
        </div>
    );
};
